import { render, staticRenderFns } from "./MyDependents.vue?vue&type=template&id=5a3dc512&"
import script from "./MyDependents.vue?vue&type=script&lang=js&"
export * from "./MyDependents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports